// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:12:42

export default {
  "id": "doomsday-tower-defense",
  "slug": "doomsday-tower-defense",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cbd803ec96e045feafead048c38557ea-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cbd803ec96e045feafead048c38557ea/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Doomsday Tower Defense",
      "description": "Survive the zombie apocalypse in this fast-paced 2D top-down tower defense game. Construct and upgrade various defensive turrets to take down hordes of undead attackers.\n\nEarn coins by killing zombies and use them to purchase new towers, upgrade existing ones, or sell for cash and reinvest into a different turret.\n\nDefend your base from waves of shambling corpses as you fight to stay alive in a world gone mad.",
      "instructions": "Construct defensive turrets. Stop the zombie horde from reaching your base.",
      "genres": [
        "Battle",
        "Strategy"
      ],
      "tags": [
        "arcade",
        "defence",
        "real-time-strategy",
        "tower",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "末日塔防",
      "description": "在这款快节奏的2D俯视视角塔防游戏中，生存于僵尸末日。构建和升级各种防御炮塔，击退成群的亡者攻击者。\n\n通过击杀僵尸赚取金币，使用金币购买新炮塔、升级现有炮塔或出售换钱再投资不同的炮塔。\n\n在疯狂的世界中，防守你的基地，同时与行尸走肉般的僵尸潮战斗，力求生存。",
      "instructions": "构建防御炮塔。阻止僵尸群抵达你的基地。",
      "genres": [
        "战斗",
        "策略"
      ],
      "tags": [
        "街机",
        "防御",
        "实时策略",
        "塔",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "末日防禦塔",
      "description": "在這款快速動作的2D俯視塔防遊戲中，生存於僵尸末日。建立和升級各種防禦砲塔，以擊敗一群群無頭僵屍攻擊者。\n\n通過擊殺僵屍獲得硬幣，用它們購買新的砲塔，升級現有的砲塔，或出售換現金並再投資於不同的砲塔。\n\n當你奮戰以求在瘋狂的世界中存活時，防禦你的基地，抵抗一波又一波的爬行屍體。",
      "instructions": "建造防禦砲塔。阻止僵尸群攻佔你的基地。",
      "genres": [
        "戰鬥",
        "策略"
      ],
      "tags": [
        "電子遊戲",
        "防禦",
        "即時策略",
        "塔防",
        "僵尸"
      ]
    },
    "zh-HK": {
      "title": "末日防禦塔",
      "description": "在這款快節奏的2D俯視塔防遊戲中，生存於僵尸末日。構建和升級各種防禦砲塔，擊敗無數的亡靈攻擊者。\n\n通過殺死僵尸獲得硬幣，用來購買新塔、升級現有塔或是賣出換現金再投資於不同的砲塔。\n\n當你為了在瘋狂的世界中生存而戰，防禦你的基地免受一波又一波的蠕動骷髏攻擊。",
      "instructions": "建造防禦砲塔。阻止僵尸群擊敗你的基地。",
      "genres": [
        "戰鬥",
        "策略"
      ],
      "tags": [
        "電玩中心",
        "防禦",
        "實時策略",
        "塔防",
        "僵屍"
      ]
    },
    "ja": {
      "title": "終日塔防塔",
      "description": "この高速な2Dトップダウン塔防ゲームでゾンビアポカリスティックを生き延びなさい。さまざまな防衛砲台を構築し、無数の死者の群れを倒す。\n\nゾンビを倒してコインを稼ぎ、新しい砲台を購入したり、既存の砲台をアップグレードしたり、現金に換え、異なる砲台に再投資するために使用する。\n\n狂った世界で生き延びるために、あなたの基地を歩き回る死体の波から守りながら戦う。",
      "instructions": "防衛砲台を構築し、ゾンビの群れが基地に近づくのを阻止せよ。",
      "genres": [
        "戦闘",
        "戦略"
      ],
      "tags": [
        "アーケード",
        "防衛",
        "リアルタイムストラテジー",
        "タワー",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "최후의 타워댐",
      "description": "초격속 2D 톱다운 타워디펜스 게임에서 좀비 대폭발을 생존하세요. 다양한 방어 타워를 건설하고 업그레이드하여 불견지른 좀비 공격자들을 물리치세요.\n\n좀비를 죽이면 동전을 얻고, 새로운 타워를 구매하거나 기존 타워를 업그레이드하거나 현금으로 팔고 다른 타워에 재투자하세요.\n\n정신이 상한 세상에서 생존을 위해 싸우는 동안, 당신의 기지를 꼼짝도 못하게 다가오는 좀비 봉오리로부터 방어하세요.",
      "instructions": "방어 타워를 건설하세요. 죽은 자 모여드는 병력을 기지에 다가오게 막으세요.",
      "genres": [
        "전투",
        "전략"
      ],
      "tags": [
        "아케이드",
        "방어",
        "실시간 전략",
        "타워",
        "증후체"
      ]
    },
    "fr": {
      "title": "Tour de Défense du Jour du Démarrage",
      "description": "Survivez l'apocalypse zombie dans ce jeu de défense en tour de guet en 2D et à vue de haut. Construisez et améliorez diverses tourelles défensives pour abattre les hordes d'ennemis non-vivants.\n\nGagnez des pièces en tuant les zombies et utilisez-les pour acheter de nouvelles tours, améliorer les existantes ou les vendre pour de l'argent et réinvestir dans une autre tourelle.\n\nDéfendez votre base contre des vagues de squelettes avachis tout en combattant pour rester en vie dans un monde devenu fou.",
      "instructions": "Construisez des tourelles défensives. Empêchez la horde de zombies de atteindre votre base.",
      "genres": [
        "Bataille",
        "Stratégie"
      ],
      "tags": [
        "arcade",
        "défense",
        "stratégie en temps réel",
        "tour",
        "zombie"
      ]
    }
  }
};
